"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgExclamation(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 72",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: (0, _jsxRuntime.jsx)("g", {
        transform: "translate(-842.000000, -169.000000)",
        fill: "currentColor",
        children: (0, _jsxRuntime.jsx)("g", {
          id: "Group-3",
          transform: "translate(799.000000, 154.000000)",
          children: (0, _jsxRuntime.jsxs)("g", {
            id: "Group-2",
            transform: "translate(43.000000, 15.000000)",
            children: [(0, _jsxRuntime.jsx)("circle", {
              id: "Oval",
              cx: "7",
              cy: "65",
              r: "7"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M1.03293239,0 L12.9603552,0 C13.51264,-1.08250786e-15 13.9603552,0.44771525 13.9603552,1 C13.9603552,1.01295684 13.9601034,1.02591246 13.9595999,1.03885952 L11.9373777,53.0388595 C11.9165037,53.5756195 11.4752987,54 10.938133,54 L2.71811757,54 C2.17844225,54 1.73612258,53.5717826 1.71864228,53.0323904 L0.0334570964,1.0323904 C0.0155683708,0.480395441 0.448547024,0.0184134324 1.00054199,0.000524706763 C1.01133525,0.0001749252 1.02213346,-1.5523285e-15 1.03293239,0 Z",
              id: "Rectangle"
            })]
          })
        })
      })
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Exclamation.js.map